/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface EmailLogItem {
  id: number
  message_id: string | null
  mailer: string
  from_address: string | null
  to_address: string
  subject: string
  status: "sent" | "failed"
  error_message?: string | null
  metadata?: Record<string, any> | null
  created_at: string
}

export interface EmailLogQueryParams extends Partial<PageQueryParams> {
  limit?: number
  status?: "sent" | "failed"
  mailer?: string
  email_type?: "verify_email" | "study_reminder" | "other" | string
  search?: string
  start_date?: string
  end_date?: string
}

export interface EmailLogListResponse {
  code: number
  data: EmailLogItem[]
  total: number
  page: number
  limit: number
}

export const emailLogService = {
  list(params: EmailLogQueryParams) {
    return HttpRequest.get("v1/email-logs", {
      searchParams: params as any,
    }).json<EmailLogListResponse>()
  },
}
